import React from "react";
import { Grid, Typography, Button, Box, Link} from "@mui/material";
import { styled } from '@mui/system';
import EastIcon from '@mui/icons-material/East';
import { useTheme } from '@mui/material/styles';
import { useLanguageContext } from "../../hooks/useContext/useLanguageContext";
import translations from "../../language";

  const ArrowText = styled(Box)({
    display: "flex",
    alignItems: "center",
    marginTop: '5%',
  });


const HeroLeft = () => {
  const theme = useTheme();
  const { language } = useLanguageContext();
  
  // Get translated text based on current language (default to 'en' if not set)
  const lang = language || 'en';
  const h1Title = translations.h1Title[lang];
  const pSubtitle = translations.pSubtitle[lang];
  const buttonText = translations.orderOnline[lang];
  const arrowButton = translations.menu[lang];

    return (
      <Grid container spacing={0}>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}
          sx={{
            paddingTop: '20%',
            paddingLeft: '10%',
            "@media (max-width: 900px)": {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: '30%',
              paddingLeft: '0%',
            },
          }}>
          <Typography variant='customFont'>
            {h1Title}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}
          sx={{
            paddingLeft: '10%',
            paddingTop: '10%',
            "@media (max-width: 900px)": {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: '5%',
              paddingLeft: '0%',
            },
          }}>
          {/* <SloganClass> */}
            <Typography variant='p' >
              {pSubtitle}
            </Typography>
          {/* </SloganClass> */}
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}
          sx={{
            paddingLeft: '10%',
            "@media (max-width: 900px)": {
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: '5%',
              paddingLeft: '0%',
            },
          }}>
          <Button type="button" href="/order" variant="primaryButton" sx={{height: "4rem", paddingLeft:'3rem', paddingRight:'3rem', marginTop: '3.75rem'}}>
              {buttonText}
          </Button>
          <ArrowText>
            <Link 
              variant="h5"
              underline="none"
              href="/Menu"
              sx={{
                color: theme.palette.common.black,
                paddingLeft:'1.75rem',
                "@media (max-width: 900px)": {
                  paddingLeft: '1rem',
                },
                ":hover": {
                  color: theme.palette.primary.dark,
                  bgcolor: 'transparent',
                },
                ":active": {
                  color: theme.palette.primary.dark,
                  bgcolor: 'transparent',
                }
                }}>
              {arrowButton}
            </Link>
            <EastIcon
              sx={{
                marginLeft: '10px',
                color: theme.palette.primary.dark,
                // ":hover": {
                //   color: theme.palette.common.black,
                //   bgcolor: 'transparent',
                // },
                // ":active": {
                //   color: theme.palette.common.black,
                //   bgcolor: 'transparent',
                // }
              }}
            />
          </ArrowText>
        </Grid>

      </Grid>
    )
}

export default HeroLeft;